import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useDispatch } from 'react-redux';
import { HIDE_ERROR } from '../../action-types/error-types';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export default function IxSnackbar({
  errorMessage,
  successMessage,
  handleSnackbarClose
}) {
  const [open, setOpen] = React.useState(errorMessage || successMessage);
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    dispatch({ type: HIDE_ERROR });
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    handleSnackbarClose && handleSnackbarClose(event, reason);
  };

  return (
    <>
      <div>
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={errorMessage ? 'error' : 'success'}
          >
            {errorMessage ? errorMessage : successMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}
